import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CreateSlug from "../extra/CreateSlug"; // adjust path as needed

/**
 * LocationSearchBox
 *
 * Props:
 *  - locations: string[]         — list of location names from context (LocationHeaders)
 *  - showSearch: boolean         — controls visibility class (passed from Header state)
 */
const LocationSearchBox = ({ locations = [], showSearch }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchQuery, setSearchQuery] = useState("");
  const [searchShow, setSearchShow] = useState(false);

  /* ─── handlers ─────────────────────────────────── */

  const handleFocus = () => setSearchShow(true);

  const handleInputChange = (e) => setSearchQuery(e.target.value);

  const handleSelect = (value) => {
    const locationData = localStorage.getItem("location");
    const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname;
    const pathSegments = currentPath.split("/");
    const locLiveSlug = pathSegments.find((seg) => seg.trim())?.trim();

    const isPrimitive =
      value !== null &&
      !Array.isArray(value) &&
      typeof value !== "object";

    if (locLiveSlug === locSlug && isPrimitive) {
      if (pathSegments.length > 1) {
        pathSegments[1] = CreateSlug(value.toLowerCase());
      }
      navigate(pathSegments.join("/"));
    } else {
      const fvalue = CreateSlug(value);
      navigate(fvalue === "object-object" ? "/" : `/${fvalue}`);
    }

    if (value) localStorage.setItem("location", value);

    setSearchQuery("");
    setSearchShow(false);
  };

  const handleClose = () => {
    setSearchQuery("");
    setSearchShow(false);
  };

  /* ─── derived ───────────────────────────────────── */

  const placeholder =
    localStorage.getItem("location") !== "[object Object]" &&
    localStorage.getItem("location")
      ? localStorage.getItem("location")
      : "Search for state and cities";

  const filteredLocations = locations.filter((loc) =>
    loc.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const dropdownOpen = searchQuery || searchShow;

  /* ─── render ─────────────────────────────────────── */

  return (
    <div
      className={`input-group d-none d-lg-flex me-5 w-100 searchbox flex-fill${
        !showSearch ? " search-view" : ""
      }`}
      style={{ backgroundColor: "#f3f7fb", maxWidth: "200px" }}
      id="tour-example"
    >
      {/* ── text input ── */}
      <input
        id="searchInput"
        className="form-control searchinput"
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleInputChange}
        onFocus={handleFocus}
        autoComplete="off"
        defaultValue={localStorage.getItem("location")}
      />

      {/* ── pin icon button ── */}
      <button
        type="button"
        className="btn bg-white d-none d-lg-block search text-secondary p-0 px-1 me-1"
        style={{ background: "white" }}
        tabIndex={-1}
      >
        <i className="ri-map-pin-2-line" />
      </button>

      {/* ── dropdown list ── */}
      {dropdownOpen && (
        <ul className="searchfloat">
          {filteredLocations.length > 0 ? (
            filteredLocations.map((item) => (
              <li key={item}>
                <button
                  type="button"
                  className="bg-transparent border-0"
                  onClick={() => handleSelect(item)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-map-pin-2-fill" /> {item}
                </button>
              </li>
            ))
          ) : (
            <li className="p-3">No matching results</li>
          )}
        </ul>
      )}

      {/* ── close button ── */}
      {dropdownOpen && (
        <button
          type="button"
          className="btn btn-primary bg-gradient d-none d-lg-block close"
          onClick={handleClose}
        >
          <i className="navbar-actions-icon ri-close-line fs-7" />
        </button>
      )}
    </div>
  );
};

export default LocationSearchBox;
